const PageEventTracker = require('../eventTracking/PageEventTracker');
const AjaxClient = require('../clients/AjaxClient');

const ajaxClient = new AjaxClient(new XMLHttpRequest());

window.pageEventTracker = new PageEventTracker(ajaxClient);
window.pageEventTracker.registerListener();